import React from 'react'
import { Form, Text } from 'components/forms'
import Button from 'components/Button'
import { notEmpty } from 'helpers/validators'
import { useMutation } from '@apollo/client'
import createDepartmentMutation from '../../gql/createDepartment'
import get from 'lodash/get'

const NewDepartment = ({ history }) => {
	const [createDepartment] = useMutation(createDepartmentMutation)
	const handleCreateDepartment = fields => {
		createDepartment({
			variables: { fields },
			refetchQueries: ['clientTree'],
			update: (cache, { data }) => {
				const id = get(data, 'cashAssist.createDepartment.id')
				history.push({
					pathname: `/optionen/kasse/geschaftsstelle/${id}`
				})
			}
		})
	}
	return(
		<Form onSubmit={handleCreateDepartment}>
			<Text label='Name' field='name' {...notEmpty()} />
			<Button type='submit' text='speichern' status='primary' size='small'/>
		</Form>
	)
}

export default NewDepartment
